export default __webpack_public_path__ + "static/media/PHÂN HỆ QUẢN LÝ HỆ THỐNG.64f6d91d.pdf";